import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.scss";
import App from "./App";
import { ChakraProvider } from "@chakra-ui/react";
import { extendTheme } from "@chakra-ui/react";
import { CookiesProvider } from "react-cookie";

import "moment/locale/id";
import moment from "moment";
moment.locale("id");

const theme = extendTheme({
  styles: {
    global: {
      body: {
        bg: "rgba(0, 0, 0, 0.04)",
      },
    },
  },
  colors: {
    custom: {
      bg: "#00122a",
      first: "#00f9ff",
      second: "#b18af8",
      third: "#e6ccef",
    },
  },
});
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <CookiesProvider>
    <ChakraProvider theme={theme}>
      <App />
    </ChakraProvider>
  </CookiesProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
